import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { thunk } from "redux-thunk";
import {sellerReducer} from "./seller/sellerSlice";
import { sellerProductSliceReducer } from "./seller/sellerProductSlice";
import { productSliceReducer } from "./customer/ProductSlice";
import { authSliceReducer } from "./AuthSlice";
import { cartItemSliceReducer } from "./customer/CartSlice";
import { orderSliceReducer } from "./customer/OrderSlice";
import { addressSliceReducer } from "./customer/AddressSlice";
import { couponSliceReducer } from "./customer/CouponSlice";

import { sellerOrderSliceReducer } from "./seller/sellerOrderSlice";
import { transactionSliceReducer } from "./seller/transactionSlice";
import { homeCategorySliceReducer } from "./admin/adminSlice";
import { wishListSliceReducer } from './customer/WishlistSlice';
import { dealSliceReducer } from "./admin/DealSlice";
import { categorySliceReducer } from "./admin/categorySlice";
import { adminSellerSliceReducer } from "./admin/adminSellerSlice";
import { reviewSliceReducer } from "./customer/ReviewSlice";
import { uiSliceReducer } from "./UiSlice";
import { sellerUploadToCloudinaryReducer } from "./seller/sellerUploadToCloudinary";



const rootReducer = combineReducers({
seller:sellerReducer,
sellerProduct:sellerProductSliceReducer,
product:productSliceReducer,
auth:authSliceReducer,
cart: cartItemSliceReducer,
order: orderSliceReducer,
addresses: addressSliceReducer,
coupon:couponSliceReducer,
wishlist:wishListSliceReducer,
sellerOrders:sellerOrderSliceReducer,
transaction: transactionSliceReducer,
homeCategory:homeCategorySliceReducer,
deal:dealSliceReducer,
category:categorySliceReducer,
adminSeller:adminSellerSliceReducer,
review:reviewSliceReducer,
ui:uiSliceReducer,
cloudinary:sellerUploadToCloudinaryReducer

})
export const store = configureStore({
    reducer: rootReducer,
    middleware:(getDefaultMiddleware)=>getDefaultMiddleware().concat(thunk)
})

export type AppDispatch = typeof store.dispatch
export type RootState= ReturnType<typeof rootReducer>
export const useAppDispatch= () => useDispatch<AppDispatch>();
export const useAppSelector:TypedUseSelectorHook<RootState>= useSelector 